import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageHeading: {
    id: 'bWXCrc',
    description: 'Main heading for the supplies landing page',
    defaultMessage: 'Recommended Supplies',
  },
  subCopy: {
    id: 'nuaDIK',
    description: 'Sub-copy explaining the supplies recommendation',
    defaultMessage: 'Select from our ShipStation-recommended supplies, rigorously tested for compatibility with the ShipStation platform.',
  },
  buyButton: {
    id: 'LO7kCG',
    description: 'Call-to-action button text for purchasing a supply item',
    defaultMessage: 'Buy for {price}',
  },
  exploreMoreHeading: {
    id: 'uwKSrd',
    description: 'Heading for the explore more section with category images',
    defaultMessage: 'Explore More',
  },
  hardwareLabel: {
    id: 'AxOCuc',
    description: 'Label for hardware category image',
    defaultMessage: 'Hardware',
  },
  labelsLabel: {
    id: 'zFzfM5',
    description: 'Label for labels category image',
    defaultMessage: 'Labels',
  },
  packagingLabel: {
    id: 'xpFmEm',
    description: 'Label for packaging category image',
    defaultMessage: 'Packaging',
  },
  shopHardware: {
    id: 'Cb96b+',
    description: 'Button text for shopping hardware supplies',
    defaultMessage: 'Shop Hardware',
  },
  shopLabels: {
    id: 'Bi64A5',
    description: 'Button text for shopping label supplies',
    defaultMessage: 'Shop Labels',
  },
  shopPackaging: {
    id: 'tZsdER',
    description: 'Button text for shopping packaging supplies',
    defaultMessage: 'Shop Packaging',
  },
  loadingProducts: {
    id: 'YExjfE',
    description: 'Loading message while products are being fetched',
    defaultMessage: 'Loading products...',
  },
  errorLoadingProducts: {
    id: 'v8bZxV',
    description: 'Error message when products fail to load',
    defaultMessage: 'Error loading products: {error}',
  },
  checkoutError: {
    id: 'F1BLLu',
    description: 'Generic error message when checkout fails',
    defaultMessage: 'Unable to complete checkout. Please try again.',
  },
  popupBlockedError: {
    id: 'bixcD+',
    description: 'Error message when popup blocker prevents checkout window from opening',
    defaultMessage: 'Popup blocked. Please allow popups for this site and try again.',
  },
  discountBadge: {
    id: '2+MdPN',
    description: 'Discount badge text showing percentage off',
    defaultMessage: '{percent}% off',
  },
});
